<template>
  <div class="home">
    <el-container>
      <el-header>
        <nav-header></nav-header>
      </el-header>
      <el-main :style="mainStyleObj">
        <el-container>
          <el-aside style="width: 220px">
            <el-row class="tac">
              <el-col :span="24">
                <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                  active-text-color="#ffd04b" unique-opened :style="mainStyleObj">
                  <el-submenu v-for="(item, index) in menuData" v-bind:key="index" :index="String(index)">
                    <template slot="title">
                      <i :class="item.icon"></i>
                      <span>{{ item.menu_name }}</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item_1, index_1) in item.menu" v-bind:key="index_1"
                        :index="index + '-' + index_1" style="text-align:center" @click="linkTo(item_1.menu_name, item_1.router)">{{
                            item_1.menu_name
                        }}</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </el-col>
            </el-row>
          </el-aside>
          <el-main :style="mainStyleObj">
            <!-- <router-view></router-view> -->
            <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
              <el-tab-pane v-for="(item) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
                <component :style="contentStyleObj" :addTab="linkTo" :param="item.param" :is="item.content"></component>
              </el-tab-pane>
            </el-tabs>
          </el-main>
        </el-container>
      </el-main>
      <el-footer>
        <nav-footer></nav-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "../components/navHeader/NavHeader.vue";
import NavFooter from "../components/navFooter/NavFooter.vue";


import order_confirm from './order/order_confirm.vue'
import order_detail from './order/order_detail.vue'
import account_son from './account/account_son.vue'
import account_password from './account/account_password.vue'
import difference_confirm from './difference/difference_confirm.vue'
import difference_detail from './difference/difference_detail.vue'
import finance_confirm from './finance/finance_confirm.vue'
import finance_detail from './finance/finance_detail.vue'
import label_exterior from './label/label_exterior.vue'
import label_item_code from './label/label_item_code.vue'
import label_search from './label/label_search.vue'
import label_detail from './label/label_detail.vue'
import power_role from './power/power_role.vue'
import return_goods_confirm from './return_goods/return_goods_confirm.vue'
import return_goods_detail from './return_goods/return_goods_detail.vue'

export default {
  name: "home",
  components: {
    NavHeader,
    NavFooter,
    order_confirm,
    order_detail,
    account_son,
    account_password,
    difference_confirm,
    difference_detail,
    finance_confirm,
    finance_detail,
    label_exterior,
    label_item_code,
    label_search,
    label_detail,
    power_role,
    return_goods_confirm,
    return_goods_detail
  },
  data() {
    return {
      mainStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      menuData: [],
      unique: true,
      editableTabsValue: '',
      editableTabs: [],
      tabIndex: ''
    };
  },
  methods: {
    //设置窗口高度
    getHeight() {
      this.mainStyleObj.height = window.innerHeight - 120 + "px";
      this.contentStyleObj.height = window.innerHeight - 120 - 41 - 15 + "px";
    },
    ////////////////////////////////
    linkTo(title, router, param='') {
      // this.$message.error(url);
      // this.$router.push("/home/" + url);
      let that = this;
      let tabs = this.editableTabs;
      for (const key in tabs) {
        if (tabs[key].name === title) {
              that.editableTabsValue = title;
              return
          }
      }
      let newTabName = title;
      this.editableTabs.push({
        title: title,
        name: newTabName,
        content: router,
        param: param
      });
      this.editableTabsValue = newTabName;
    },
    /**
     * 获取菜单
     */
    async getMenu() {
      let res = await this.$Http.getMenu();
      if (res.code == 0) {
        let menu = [];
        let i = 0;
        res.data.forEach((element) => {
          if (!element.superior_id) {
            menu.push({
              menu_id: element.menu_id,
              menu_name: element.menu_name,
              router: element.router,
              icon: element.icon,
              menu: [],
            });
            i++;
          }
          if (element.superior_id) {
            menu[i - 1].menu.push({
              menu_id: element.menu_id,
              menu_name: element.menu_name,
              router: element.router,
            });
          }
        });
        this.menuData = menu;
      } else {
        this.$message.error(res.msg);
      }
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
    }
  },
  created() {
    // window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getMenu();
  }
};
</script>
<style scoped>
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: left;
  line-height: 200px;
}

.el-main {
  /* background-color: #e9eef3;
  color: #333;
  text-align: center; */
  /* line-height: 160px; */
  padding: 0;
}

body>.el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
